import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=007c4702&scoped=true&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"
import style0 from "./Layout.vue?vue&type=style&index=0&id=007c4702&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./Layout.vue?vue&type=style&index=1&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007c4702",
  null
  
)

export default component.exports